import Profile from '@/models/Profile';

const GET_WORK_PROCESSES = 'get_workProcesses';
const GET_WORK_PROCESSES_REQUEST = 'get_workProcesses_request';
const GET_WORK_PROCESSES_SUCCESS = 'get_workProcesses_success';
const GET_WORK_PROCESSES_ERROR = 'get_workProcesses_error';

export { GET_WORK_PROCESSES };

export default {
    state: {
        id: 0,
        workProcesses: [],
        loading: false,
        workProcessesErrors: [],
        workProcessesMeta: {},
    },
    mutations: {
        [GET_WORK_PROCESSES_REQUEST]: (state) => {
            state.workProcesses = [];
            state.loading = true;
            state.workProcessesErrors = [];
        },
        [GET_WORK_PROCESSES_SUCCESS]: (state, { workProcesses, meta }) => {
            state.workProcesses = workProcesses;
            state.loading = false;
            state.workProcessesErrors = [];
            state.workProcessesMeta = meta;
        },
        [GET_WORK_PROCESSES_ERROR]: (state, { errors }) => {
            state.workProcesses = [];
            state.loading = false;
            state.workProcessesErrors = errors;
            state.workProcessesMeta = {};
        },
    },
    actions: {
        [GET_WORK_PROCESSES]: ({ commit, state }, { id = state.id, page = state.workProcessesMeta.current_page }) => {
            commit(GET_WORK_PROCESSES_REQUEST);
            return new Promise((resolve, reject) => {
                if (localStorage.getItem('y2t4784h89r3ijq')) {
                    const data = JSON.parse(localStorage.getItem('y2t4784h89r3ijq'));
                    commit(GET_WORK_PROCESSES_SUCCESS, data);
                    return resolve(data.data);
                }
                Profile.workProcesses(id, page)
                    .then(({data, meta}) => {
                        const workProcesses = data;
                        commit(GET_WORK_PROCESSES_SUCCESS, { workProcesses, meta });
                        localStorage.setItem('y2t4784h89r3ijq', JSON.stringify({ workProcesses, meta }));
                        resolve(data);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_WORK_PROCESSES_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/work-processes.js